import { fetchAuthorizedJsonApi, fetchJsonApi } from './abstract';
import { REWARDED_VIDEO_LOOTPACK_PLATFORMS } from '../constants';
import { getPlatform, getProvider } from './platform';
export function fetchCollections(apiUrl, country) {
    return fetchJsonApi({
        apiUrl: apiUrl,
        body: undefined,
        skipHumanVerification: undefined,
        method: 'GET',
        endpoint: 'v1/card-collections',
        query: { country: country },
        expectedStatus: 200,
        description: 'Fetching cards',
    });
}
export function fetchOwnedCollections(apiUrl, token, country) {
    return fetchAuthorizedJsonApi({
        apiUrl: apiUrl,
        token: token,
        body: undefined,
        method: 'GET',
        endpoint: 'v1/card-collections/u/owned',
        query: {
            country: country,
            platform: getPlatform(),
            rewardedVideoLootpack: REWARDED_VIDEO_LOOTPACK_PLATFORMS[getProvider()],
        },
        expectedStatus: 200,
        description: 'Fetching owned collections',
    });
}
export function fetchCollectionProgress(apiUrl, token, collectionIdOrAlias, country) {
    return fetchJsonApi({
        apiUrl: apiUrl,
        query: {
            country: country,
            platform: getPlatform(),
            rewardedVideoLootpack: REWARDED_VIDEO_LOOTPACK_PLATFORMS[getProvider()],
        },
        skipHumanVerification: undefined,
        headers: token ? { Authorization: "Bearer ".concat(token) } : undefined,
        body: undefined,
        method: 'GET',
        endpoint: "v1/card-collections/".concat(collectionIdOrAlias, "/progress"),
        expectedStatus: 200,
        description: 'Fetching collection progress',
    });
}
export function updateCollection(apiUrl, token, collectionId, slots, country) {
    return fetchAuthorizedJsonApi({
        apiUrl: apiUrl,
        query: {
            country: country,
            platform: getPlatform(),
            rewardedVideoLootpack: REWARDED_VIDEO_LOOTPACK_PLATFORMS[getProvider()],
        },
        token: token,
        method: 'PUT',
        body: { slots: slots },
        endpoint: "v1/card-collections/".concat(collectionId, "/progress"),
        expectedStatus: 200,
        description: 'Updating collection',
    });
}
export function submitCollection(apiUrl, token, collectionId, slots) {
    return fetchAuthorizedJsonApi({
        apiUrl: apiUrl,
        token: token,
        method: 'POST',
        body: { slots: slots },
        endpoint: "v1/card-collections/".concat(collectionId, "/progress"),
        expectedStatus: 200,
        description: 'Submitting collection',
    });
}
export function hideCollection(apiUrl, token, collectionId) {
    return fetchAuthorizedJsonApi({
        apiUrl: apiUrl,
        token: token,
        method: 'PUT',
        body: undefined,
        endpoint: "v1/card-collections/".concat(collectionId, "/hide"),
        expectedStatus: 204,
        description: 'Hiding collection',
    });
}
export function fetchRanking(apiUrl, token, collectionIdOrAlias) {
    return fetchJsonApi({
        apiUrl: apiUrl,
        headers: token
            ? {
                Authorization: "Bearer ".concat(token),
            }
            : undefined,
        method: 'GET',
        endpoint: "v1/card-collections/".concat(collectionIdOrAlias, "/ranking"),
        expectedStatus: 200,
        description: 'Fetching collection ranking',
        body: undefined,
        skipHumanVerification: undefined,
    });
}
